export default "__VITE_ASSET__956e4d3e__"